import { ApiRequest, ApiResponse } from "@/api/types";

export enum MenuType {
  MENU_DEFAULT = "default",
  MENU_SCOUT_AGENT = "scout_agent"
}

export interface ScoutPlan {
  scoutPlan: number | undefined;
  remainingTicketsCount: number | undefined;
  expirationAtMs: number | undefined;
  scoutTargetGraduateYears: string[];
}

export interface State {
  partnerUser?: ApiResponse.PartnerUser;
  availableContracts: ApiResponse.Contract[];
  expiredContracts: ApiResponse.Contract[];
  loadingStatus: boolean;
  passwordReissue: ApiRequest.PasswordReissue;
  passwordReset: ApiRequest.PasswordReset;
  scoutPlan: ScoutPlan;
  savedSearchOptionCount: number | undefined;
  menuType: MenuType;
}
export interface Actions {
  signIn: ApiRequest.SignIn;
  signInToken: ApiRequest.SignInToken;
  signOut: void;
  getPartnerUser: void;
  getContracts: void;
  passwordReissue: ApiRequest.PasswordReissue;
  passwordReset: ApiRequest.PasswordReset;
  scoutPlan: ScoutPlan;
  savedSearchOptionCount: number;
  changeMenuType: MenuType;
}
export interface RootActions {
  "domains/user/signIn": Actions["signIn"];
  "domains/user/signInToken": Actions["signInToken"];
  "domains/user/signOut": Actions["signOut"];
  "domains/user/getPartnerUser": Actions["getPartnerUser"];
  "domains/user/getContracts": Actions["getContracts"];
  "domains/user/passwordReissue": Actions["passwordReissue"];
  "domains/user/passwordReset": Actions["passwordReset"];
  "domains/user/scoutPlan": Actions["scoutPlan"];
  "domains/user/savedSearchOptionCount": Actions["savedSearchOptionCount"];
  "domains/user/changeMenuType": Actions["changeMenuType"];
}
export interface Getters {
  isLoggedIn: boolean;
  isScoutAgentMenuActive: boolean;
}
export interface RootGetters {
  "domains/user/isLoggedIn": Getters["isLoggedIn"];
  "domains/user/isScoutAgentMenuActive": Getters["isScoutAgentMenuActive"];
}
export interface Mutations {
  loadingStarted: boolean;
  loadingFinished: boolean;
  signInSuccess: { partnerUser: ApiResponse.PartnerUser };
  updateUser: { partnerUser: ApiResponse.PartnerUser | undefined };
  updateContracts: {
    availableContracts: ApiResponse.Contract[];
    expiredContracts: ApiResponse.Contract[];
  };
  passwordReissue: ApiRequest.PasswordReissue;
  passwordReset: ApiRequest.PasswordReset;
  scoutPlan: ScoutPlan;
  savedSearchOptionCount: number;
  changeMenuType: MenuType;
}
export interface RootMutations {
  "domains/user/loadingStarted": Mutations["loadingStarted"];
  "domains/user/loadingFinished": Mutations["loadingFinished"];
  "domains/user/signInSuccess": Mutations["signInSuccess"];
  "domains/user/updateUser": Mutations["updateUser"];
  "domains/user/updateContracts": Mutations["updateContracts"];
  "domains/user/passwordReissue": Mutations["passwordReissue"];
  "domains/user/passwordReset": Mutations["passwordReset"];
  "domains/user/scoutPlan": Mutations["scoutPlan"];
  "domains/user/savedSearchOptionCount": Mutations["savedSearchOptionCount"];
  "domains/user/changeMenuType": Mutations["changeMenuType"];
}
